module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/nba/steals/basketball_steals-3ce358bc351bc2a545879cf5ca85354d.svg";